import {Component, Input, OnInit} from '@angular/core';
import {ConfigStructure} from "../../../../config/config-structure.model";
import {Translator} from "../../../../search/fulltext/translator";
import {AppUtils} from "../../../app-utils";
import {AppConfigService} from "../../../../config/app-config.service";
import {TranslatorService} from "../../../translator.service";
import {Router} from "@angular/router";
import {MaterializationDetails} from "../../../../search/fulltext/materialization-details";
import {ResultDetails} from "../../../../search/fulltext/result-details";
import {Property} from "../../../property/property.model";
import {FulltextService} from "../../../../search/fulltext/fulltext.service";

@Component({
  selector: 'app-result-object-fulltext',
  templateUrl: './result-object-fulltext.component.html',
  styleUrls: ['./result-object-fulltext.component.scss']
})
export class ResultObjectFulltextComponent implements OnInit {

  private matBaseUrl: string = '/materialization/';

  loaded = false;

  @Input() searchInText: boolean;

  @Input() objectId: string;


  private phrase: string;

  @Input("phrase") set _phrase(value: string) {
    this.phrase = value;
  }

  @Input("loaded") set _loaded(value: boolean) {
    this.loaded = value;
  }

  @Input() resultDetails: ResultDetails;

  visible: boolean = false;

  originalResultDetails: ResultDetails;

  highlightSize: number;

  highlights: string[];

  translationCount: number = 2;

  currMatNr: number;

  currMatId: any;

  currentPage: number = 0;

  currMaterialization: any;

  private properties: Property[];

  currTranslators: Translator[];

  matUrl: string;

  currentText: string;

  materializations = [];

  fulltextConfig: ConfigStructure [];

  matProperties: Property [] = [];

  constructor(private fulltextService: FulltextService,
              private appConfig: AppConfigService,
              private router: Router,
              private translator: TranslatorService) {
    this.fulltextConfig = appConfig.fulltextConfig.bookConfig;
  }

  ngOnInit() {
    if (this.searchInText && this.resultDetails && this.resultDetails.highlightCount > 0) {
      this.onInit(this.resultDetails);
    }
  }

  private onInit(resultDetails: ResultDetails) {
    this.visible = true;
    this.originalResultDetails = {...resultDetails};
    this.materializations = this.getAllMaterializations(this.originalResultDetails);
    this.updateCounters(resultDetails);
    this.changePage(0);
  }

  getNextFulltext() {
    this.changePage(1);
  }

  getPreviousFulltext() {
    this.changePage(-1);
  }

  private initValues() {
    this.currMaterialization = this.resultDetails.matDetails[this.currMatNr].data;
    this.updateMatDetails(this.currMaterialization);
    this.currMatId = ResultObjectFulltextComponent.getMatId(this.currMaterialization);
    this.updateMatProperties(
      this.currMaterialization,
      this.highlights[this.currentPage],
      this.resultDetails.matDetails[this.currMatNr]);
  }

  private changePage(diff: number): void {
    if (diff === undefined) {
      this.currentPage = 0;
      this.currMatNr = 0;
      this.updateCounters(this.resultDetails);
      this.initValues();
    }
    if (this.currentPage + diff >= 0 && this.currentPage + diff < this.highlightSize) {
      this.currentPage += diff;
      let nextMatNr = this.changeMaterialization(this.currentPage);
      if (nextMatNr !== this.currMatNr) {
        this.currMatNr = nextMatNr;
        this.initValues();
      }
      else {
        this.updateCurrText(this.highlights[this.currentPage]);
      }
    }
  }

  matSelected($event) {
    this.updateAvailableOptions($event.target.value);
  }

  private updateAvailableOptions(matNr: any) {
    if (matNr === "") {
      this.resultDetails = {...this.originalResultDetails};
      this.updateCounters(this.resultDetails);
      this.changePage(undefined);
    }
    else {
      this.resultDetails.matDetails = [this.originalResultDetails.matDetails[matNr]];
      this.resultDetails.highlightCount = this.resultDetails.matDetails[0].highlight.length;
      this.resultDetails.translatorCount = this.resultDetails.matDetails[0].translators.length;
      this.updateCounters(this.resultDetails);
      this.changePage(undefined);
    }
  }

  private changeMaterialization(page: number): number {
    let h = 0;
    for (let i = 0; i < this.resultDetails.matCount; i++) {
      h += this.resultDetails.matDetails[i].highlight.length;
      if (h > page) {
        return i;
      }
    }
    return page;
  }

  private updateMatProperties(currMaterialization: string, highlight: string, matDetails: MaterializationDetails) {
    this.updateMatUrl();
    this.updateTranslators(matDetails);
    this.updateMatDetails(currMaterialization);
    this.updateCurrText(highlight);
  }

  private updateMatUrl() {
    this.matUrl = this.matBaseUrl + this.currMatId;
  }

  public getTranslatorUrl(translator: Translator): string {
    if (translator.translatorId && translator.translatorType) {
      return '/' + translator.translatorType + '/' + translator.translatorId;

    }
  }

  redirectToTranslator(url: string, trans: Translator) {
    if (ResultObjectFulltextComponent.isTranslatorUrlValid(trans))
      this.router.navigateByUrl(url);
  }

  redirectToMaterialization() {
    this.updateMatUrl();
    if (this.matUrl) {
      this.router.navigateByUrl(this.matUrl);
    }
  }

  private static isTranslatorUrlValid(trans: Translator) {
    return trans.translatorId && trans.translatorType;
  }

  getArrayOfTranslators(matDetails: MaterializationDetails): Translator[] {
    this.currTranslators = [];
    if (matDetails) {
      for (let trans of matDetails.translators) {
        this.currTranslators.push(trans);
      }
    }
    return this.currTranslators;
  }

  private updateMatDetails(currMaterialization: string) {
    this.matProperties = AppUtils.mapObjectToProperties(JSON.parse(currMaterialization));
  }

  private updateCurrText(highlight: string) {
    this.currentText = highlight;
  }

  private static getMatId(materialization: string): string {
    let json = JSON.parse(materialization);
    return json.id;
  }

  private updateTranslators(matDetails: MaterializationDetails) {
    this.getArrayOfTranslators(matDetails);
  }

  private updateCounters(resultDetails: ResultDetails) {
    this.currentPage = 0;
    this.highlightSize = resultDetails.highlightCount;
    this.highlights = ResultObjectFulltextComponent.getAllHighlights(resultDetails);
    this.translationCount = resultDetails.translatorCount;
  }

  private static getAllHighlights(resultDetails: ResultDetails): string [] {
    let result: string[] = [];
    for (let mat of resultDetails.matDetails) {
      result.push(...mat.highlight);
    }
    return result;
  }

  private getAllMaterializations(resultDetails: ResultDetails): { nr, name }[] {

    let result: any = [];

    for (let i = 1; i <= resultDetails.matDetails.length; i++) {
      let name = JSON.parse(resultDetails.matDetails[i - 1].data).mat_title_proper;
      result.push({nr: i - 1, name: name ? name : 'Materializacja ' + i});
    }

    return result;
  }

  getDeferResultDetails(): void {
    if (!this.visible && this.searchInText) {
      this.fulltextService
        .getMaterializationsByObjectIdsAndQuery([+this.objectId], this.phrase).subscribe(result => {
        if (result && result.length > 0 && result[0].highlightCount > 0) {
          this.onInit(result[0]);
        }
      }, error => {
        console.error("Cannot load fulltext. Reason:", error);
      });
    }
  }

}
